const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Zoom settings component
 * @argument {Application} Application injected to gain access to the global Application service
 * @argument {MicrosoftTeams} MicrosoftTeams injected to gain access to the MicrosoftTeams resource
 */
app.directive('microsoftRedirect', ['Application', 'MicrosoftTeams', function (Application, MicrosoftTeams) {
  return {
    restrict: "E",
    replace: true,
    scope : {
    },
    template: require('../../templates/directives/microsoft-redirect.html'),
    controller: ['$scope', function ($scope) {
      const self = this;

      self.featureFlags = Application.features.flags();
      self.user = Application.access.user;
      self.userId = self.user._id;
      self.companyId = Application.access.user.company;

      self.checkParams = function() {
        const params = Application.navigation.getUrlParameters();
        const authCode = params.code;
        if (authCode === "undefined" || !authCode) { // "undefined" string returned when user cancels mid-integration
          self.clearParamsAndRedirect(false);
        } else {
          MicrosoftTeams.createIntegration({authCode}).$promise
            .then(function(res) {
              self.clearParamsAndRedirect(true);
            })
            .catch(function(e) {
              console.error('Error integrating Microsoft Teams', e);
              self.clearParamsAndRedirect(false);
            });  
        }
      };

      self.clearParamsAndRedirect = function(isSuccessful) {
        if (isSuccessful) {
          Application.messaging.addMessage({type: 'success', text: 'Microsoft Teams integration successful', duration: 5});
        } else {
          Application.messaging.addMessage({type: 'error', text: 'Microsoft Teams integration unsuccessful', duration: 5});
        }
        Application.navigation.clearUrlParameters();
        Application.navigation.goTo('/dashboard/settings'); 
      }
      
      self.initialize = function () {
        if (!self.featureFlags.microsoft_teams_meetings) {
          Application.navigation.goTo('/explore');
          return;
        }
        self.checkParams();
      };
      self.initialize();
    }],
    controllerAs: 'microsoftRedirect'
  };
}]);
